import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, change } from 'redux-form';
import { t } from 'i18next';
import putReduxCompanies from './actions';
import {
  createContact,
  updateContactById,
  getContactInfo,
} from '../../services/contacts';
import {
  getCompaniesList,
} from '../../services/companies';
import { formDataToApi, formApiToData } from '../../services/contacts/helpers';
import {
  ButtonGroup,
  FormContainer,
} from './css';
import ContactForm from './components/ContactForm';
import { homeUrlNoTrailingSlash } from '../../utils/func';
import { routes } from '../../utils/constants';
import LeavePageModal from '../ReactComponent/LeavePageModal';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';

const formName = 'CreateContactForm';
const initialValues = {
  companies: [{}],
};

class CreateContactForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      companiesList: [],
      contactId: '',
      modalIsOpen: false,
    };
  }

  componentDidMount() {
    this.fetchAllCompanies().then(() => {
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('contactId')) {
          this.setState({ contactId: urlParams.get('contactId') });
          this.handleId(
            urlParams.get('contactId'),
          );
        }
      }
    });
  }

  handleId = (Id) => {
    getContactInfo(Id)
      .then((response) => {
        if (response.data) {
          const { data } = response;
          const formedData = formApiToData(data);
          this.dispatchFormValues(formedData);
        }
      });
  };

  dispatchFormValues = (data) => {
    const { dispatch } = this.props;
    Object.keys(data).map((field) => dispatch(change(formName, field, data[field])));
  };

  fetchAllCompanies = () => {
    const { division, userId } = this.props;
    return getCompaniesList(division, userId).then((res) => {
      if (res.status === 200) {
        const { putReduxCompanies } = this.props;
        putReduxCompanies(res.data);
        this.setState({ companiesList: res.data });
      }
    });
  };

  goToManage = (e) => {
    if (e) {
      e.preventDefault();
    }

    const manageContactsUrl = `${homeUrlNoTrailingSlash()}${routes.manageContacts}`;
    window.location.href = manageContactsUrl;
  };

  handleSubmit = () => {
    const {
      formData,
      isAuthenticated,
    } = this.props;
    const { contactId, companiesList } = this.state;
    if (isAuthenticated) {
      const changedData = formDataToApi(formData, companiesList);
      if (formData.rowVersion) {
        updateContactById(changedData, contactId).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.goToManage();
          }
        });
      } else {
        createContact(changedData).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.goToManage();
          }
        });
      }
    }
  };

  render() {
    const {
      formData, handleSubmit, fields, dispatch,
    } = this.props;
    const { companiesList, modalIsOpen } = this.state;
    return (
      <>
        <LeavePageModal isOpen={modalIsOpen} onClose={() => this.setState({ modalIsOpen: false })} onContinue={() => this.goToManage()} />
        <FormContainer>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <ContactForm
              formData={formData}
              formName={formName}
              companiesList={companiesList}
              parentFields={fields}
              dispatch={dispatch}
            />
            <ButtonGroup>
              <SecondaryButton showArrow isIconLeftPosition onClick={() => this.setState({ modalIsOpen: true })}>
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton type="submit">
                {t('SaveChanges')}
              </PrimaryButton>
            </ButtonGroup>
          </form>
        </FormContainer>
      </>
    );
  }
}

CreateContactForm = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(CreateContactForm);

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  isAuthenticated: state.profile.isAuthenticated,
  division: state.profile.division,
  userId: state.profile.userId,
});

const mdtp = (dispatch) => ({
  putReduxCompanies: (companiesList) => dispatch(putReduxCompanies(companiesList)),
});

export default connect(mstp, mdtp)(CreateContactForm);

CreateContactForm.propTypes = {
  formData: PropTypes.shape({
    rowVersion: PropTypes.string,
  }),
  handleSubmit: PropTypes.func,
  fields: PropTypes.object,
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  division: PropTypes.string,
  userId: PropTypes.string,
  putReduxCompanies: PropTypes.func,
};
